import { render, staticRenderFns } from "./EditStoreGiftListCategoryComponent.vue?vue&type=template&id=53c4346c&scoped=true"
import script from "./EditStoreGiftListCategoryComponent.vue?vue&type=script&lang=js"
export * from "./EditStoreGiftListCategoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c4346c",
  null
  
)

export default component.exports